import { render, staticRenderFns } from "./BuildingSocietyRegistry.vue?vue&type=template&id=0f0c80e6&scoped=true&"
import script from "./BuildingSocietyRegistry.vue?vue&type=script&lang=js&"
export * from "./BuildingSocietyRegistry.vue?vue&type=script&lang=js&"
import style0 from "./BuildingSocietyRegistry.vue?vue&type=style&index=0&id=0f0c80e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0c80e6",
  null
  
)

export default component.exports